<section id="projects" class="recent-projects">
  <div class="recent-projects__container">
    <header class="recent-projects__header">
      <h5 class="recent-projects__subtitle">GALLERY</h5>
      <h2 class="recent-projects__title">Our Projects</h2>
      <div class="recent-projects__divider"></div>
      <p class="recent-projects__description">
        Explore our portfolio of flooring transformations. Each project showcases our commitment to quality craftsmanship and attention to detail.
      </p>

      <nav class="recent-projects__tabs" role="tablist" aria-label="Project category filters">
        <button
          class="recent-projects__tab"
          [class.recent-projects__tab--active]="activeTab() === 'all'"
          (click)="setActiveTab('all')"
          role="tab"
          [attr.aria-selected]="activeTab() === 'all'"
          type="button">
          All Projects
        </button>
        <!-- НОВАЯ КНОПКА FINISHING ЗДЕСЬ -->
        <button
          class="recent-projects__tab"
          [class.recent-projects__tab--active]="activeTab() === 'finishing'"
          (click)="setActiveTab('finishing')"
          role="tab"
          [attr.aria-selected]="activeTab() === 'finishing'"
          type="button">
          Finishing
        </button>
        <button
          class="recent-projects__tab"
          [class.recent-projects__tab--active]="activeTab() === 'sanding'"
          (click)="setActiveTab('sanding')"
          role="tab"
          [attr.aria-selected]="activeTab() === 'sanding'"
          type="button">
          Sanding
        </button>
        <button
          class="recent-projects__tab"
          [class.recent-projects__tab--active]="activeTab() === 'installations'"
          (click)="setActiveTab('installations')"
          role="tab"
          [attr.aria-selected]="activeTab() === 'installations'"
          type="button">
          Installations
        </button>
        <button
          class="recent-projects__tab"
          [class.recent-projects__tab--active]="activeTab() === 'preparation'"
          (click)="setActiveTab('preparation')"
          role="tab"
          [attr.aria-selected]="activeTab() === 'preparation'"
          type="button">
          Preparation
        </button>
      </nav>
    </header>

    <div class="recent-projects__grid">
      @for (project of projectCards(); track project.title) {
        <article class="recent-projects__card project-card" (click)="openProjectGallery(project, $event)">
          <div class="project-card__image-wrapper">
            <img
              [src]="project.image"
              [alt]="project.title + ' project image'"
              class="project-card__image"
              loading="lazy"
            />
          </div>
          <div class="project-card__content">
            <h3 class="project-card__title">{{ project.title }}</h3>
            <h5 class="project-card__subtitle">{{ project.subtitle }}</h5>
            <div class="project-card__footer">
              <span class="project-card__location">{{ project.location }}</span>
              <button
                class="project-card__arrow"
                type="button"
                [attr.aria-label]="'View ' + project.title + ' details'"
                (click)="openProjectGallery(project, $event)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </article>
      }
    </div>

    <!-- Hidden gallery container for lightGallery -->
    @if (isBrowser) {
      <div #galleryContainer class="recent-projects__gallery-container" aria-hidden="true"></div>
    }
  </div>
</section>